import { Link } from "react-router-dom";
import { Wifi, Tv, Satellite, ArrowRight, CheckCircle2 } from "lucide-react";
import { CoverageChecker } from "./CoverageChecker";

const offerings = [
  {
    id: "internet-cable-tv",
    icons: [Wifi, Tv],
    overline: "Connectivity Services",
    title: "Business Internet & Cable TV",
    desc: "Dedicated, reliable connectivity and commercial TV packages for offices, hospitality, healthcare, and multi-location operations — sourced and negotiated across the nation's leading carriers.",
    capabilities: [
      "Dedicated Fiber & Broadband/Coax Internet",
      "Commercial Cable TV & DIRECTV for Business",
      "Static IPs, SLAs & 24/7 Carrier Support",
      "Multi-Location Aggregation & Single Billing",
    ],
    service: "Business Internet & Cable TV",
    cta: "Inquire About Internet & Cable TV",
    testid: "connectivity-internet-cable",
  },
  {
    id: "satellite-internet",
    icons: [Satellite],
    overline: "Beyond the Fiber Map",
    title: "Satellite Business Internet",
    desc: "High-speed LEO and GEO satellite connectivity for rural sites, remote operations, and mission-critical failover — deployed rapidly anywhere traditional carriers can't reach.",
    capabilities: [
      "LEO Satellite (Starlink Business-class) & GEO Options",
      "Rural, Remote & Temporary Site Coverage",
      "Automatic Failover & Backup Connectivity",
      "Rapid Deployment — No Trenching or Build-Out",
    ],
    service: "Satellite Business Internet",
    cta: "Inquire About Satellite Internet",
    testid: "connectivity-satellite",
  },
];

export const ConnectivityServices = () => (
  <section id="connectivity" data-testid="connectivity-section" className="py-24 md:py-32 bg-[#0B1035] border-b border-white/10">
    <div className="max-w-7xl mx-auto px-6 md:px-12 space-y-12">
      {offerings.map((o, idx) => (
        <div key={o.id} data-testid={o.testid}
          className={`grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center border border-white/10 bg-[#05071F] p-8 sm:p-12 ${idx === 1 ? "lg:[direction:rtl]" : ""}`}>
          <div className="lg:[direction:ltr]">
            <div className="flex items-center gap-3 mb-6">
              {o.icons.map((Icon, i) => <Icon key={i} className="w-8 h-8 text-cyan-400" />)}
            </div>
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-violet-400 mb-3">{o.overline}</p>
            <h2 className="font-heading text-3xl sm:text-4xl tracking-tight font-medium text-white">{o.title}</h2>
            <p className="mt-5 text-slate-400 leading-relaxed">{o.desc}</p>
            <Link to={`/connectivity-inquiry?service=${encodeURIComponent(o.service)}`} data-testid={`${o.testid}-cta`}
              className="mt-8 inline-flex items-center gap-2 bg-cyan-400 text-[#05071F] font-semibold px-7 py-3.5 rounded-full hover:bg-cyan-300 transition-colors">
              {o.cta} <ArrowRight className="w-4 h-4" />
            </Link>
            <p className="mt-4 text-xs text-slate-500">Quick two-minute form — goes directly to our service desk, service@silentsentrycorp.com</p>
          </div>
          <ul className="space-y-4 lg:[direction:ltr]">
            {o.capabilities.map((c) => (
              <li key={c} className="flex gap-3 items-start bg-[#0B1035] border border-white/10 p-4">
                <CheckCircle2 className="w-5 h-5 text-cyan-400 shrink-0 mt-0.5" />
                <span className="text-sm text-slate-200">{c}</span>
              </li>
            ))}
          </ul>
        </div>
      ))}
      <CoverageChecker />
    </div>
  </section>
);
